import { useCallback, useEffect, useState } from "react";
import {
  attachDevToolsBlockListeners,
  calibrateDevToolsBaseline,
  detectDevToolsOpen,
  isDevToolsBlockEnabled,
} from "../utils/devtools-block";

const POLL_INTERVAL_MS = 1000;
const BASELINE_DELAY_MS = 500;

export const useDevToolsBlock = () => {
  const enabled = isDevToolsBlockEnabled();
  const [isDevToolsOpen, setIsDevToolsOpen] = useState(false);

  const refreshDevToolsState = useCallback(() => {
    if (!enabled) {
      setIsDevToolsOpen(false);
      return;
    }

    setIsDevToolsOpen(detectDevToolsOpen());
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const calibrateTimeout = window.setTimeout(() => {
      calibrateDevToolsBaseline();
      refreshDevToolsState();
    }, BASELINE_DELAY_MS);

    const intervalId = window.setInterval(refreshDevToolsState, POLL_INTERVAL_MS);

    window.addEventListener("resize", refreshDevToolsState);
    window.addEventListener("focus", refreshDevToolsState);

    const detachListeners = attachDevToolsBlockListeners(refreshDevToolsState);

    return () => {
      window.clearTimeout(calibrateTimeout);
      window.clearInterval(intervalId);
      window.removeEventListener("resize", refreshDevToolsState);
      window.removeEventListener("focus", refreshDevToolsState);
      detachListeners();
    };
  }, [enabled, refreshDevToolsState]);

  return {
    enabled,
    isDevToolsOpen,
  };
};
